import { render } from "./UserProfileBanControl.vue?vue&type=template&id=59cf2eb8&ts=true"
import script from "./UserProfileBanControl.vue?vue&type=script&lang=ts"
export * from "./UserProfileBanControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__